import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import {setCookie,getCookie,delCookie} from './common/js/cookie.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-chalk/display.css'

// import rawDisplayer from "./components/global/raw-displayer.vue";
// import searchApp from "./components/global/searchApp.vue";
import searchApp from "./components/searchApp.vue";


import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import 'font-awesome/css/font-awesome.min.css'

import './public.scss'

import * as filters from './filters'; // 全局vue filter

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
// Vue.component("rawDisplayer", rawDisplayer);
Vue.component("searchApp", searchApp);

Vue.prototype.$cookie={setCookie,getCookie,delCookie};

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login') {
    delCookie('login');
    delCookie('user');
  }
  let login = getCookie('login');
  if (!login && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js